<mat-sidenav-container fxFlexFill autosize>
  <mat-sidenav class="app-sidenav"
    class="app-sidenav"
    [opened]="uiState.showSideNav$ | async"
    (openedChange)="uiState.showSideNav$.next($event)"
    [mode]="uiState.sideNavModeMediaQuery.matches ? 'over' : 'side'"
    [class.mat-elevation-z8]="uiState.showSideNav$ | async"
    [style]="'background-color:' + navColor"
  >
    <div fxLayout="column" fxLayoutAlign="space-between">
      <div fxFlex="64px">
        <mat-toolbar color="secundary" [style]="'background-color:' + navColor">
          <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between center">
            <div class="sidenav__title">Hoofdmenu</div>
            <button *ngIf="uiState.sideNavModeMediaQuery.matches" (click)="uiState.toggleSideNav()" mat-icon-button>
              <mat-icon>arrow_back</mat-icon>
            </button>
          </div>
        </mat-toolbar>
      </div>
      <div class="sidenav__content" fxFlex="1 1 calc(100vh - 64px)">
        <mat-accordion displayMode="flat" [multi]="false">

          <!-- INVENTARIS -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title><mat-icon class="panel-icon">inventory_2</mat-icon> Inventaris</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              <ng-container *screenResource="['DASHBOARD', 'READ']">
                <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity && appState.moduleDashboard$.value" (click)="uiState.toggleSideNav()" routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
              </ng-container>
              <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/dossiers" routerLinkActive="active">Dossiers</a>
              <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/eigenaars" routerLinkActive="active">Eigenaars</a>
              <a mat-list-item *screenResource="['REPORTS', 'READ']" (click)="uiState.toggleSideNav()" routerLink="/reports/list-rpt" [routerLinkActiveOptions]="ignoreQueryMatching" routerLinkActive="active" [queryParams]="{ type: 'dossier' }">Rapportering</a>
              <ng-container *screenResource="['EXPORTOVERZICHT', 'READ']">
                <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/export-overzicht" routerLinkActive="active">Overzichten</a>
              </ng-container>
              <a mat-list-item *screenResource="['REPORTS', 'READ']" (click)="uiState.toggleSideNav()" routerLink="/reports/list-wo" [routerLinkActiveOptions]="ignoreQueryMatching" routerLinkActive="active" [queryParams]="{ type: 'inventaris' }">Werkopdrachten</a>
              <ng-container *ngIf="this.appState.activeCommunity$.value.IsCommunity">
                <a mat-list-item *screenResource="['FINANCIEELDIENST', 'READ']" (click)="uiState.toggleSideNav()" routerLink="/export-financiele-dienst" routerLinkActive="active">Financiële dienst</a>
              </ng-container>
              <ng-container *screenResource="['VERMOEDENSLIJSTIMPORT', 'READ']">
                <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity && moduleVermoedensLijst" (click)="uiState.toggleSideNav()" routerLink="/vermoedenslijst" routerLinkActive="active">Vermoedenslijst</a>
              </ng-container>
              <ng-container *screenResource="['BRIEVEN', 'READ']">
                <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/brievenplanning" routerLinkActive="active">Brievenplanning</a>
              </ng-container>
              <ng-container *screenResource="['SHAREPOINT', 'READ']">
                <a mat-list-item *ngIf="rootFolderLink" (click)="navigateRootDrive()">Naar Sharepoint</a>
              </ng-container>
            </mat-nav-list>
          </mat-expansion-panel>

          <!-- LOKET -->
          <ng-container *screenResource="['LOKET', 'READ']">
            <mat-expansion-panel *ngIf="moduleLoket && this.appState.activeCommunity$.value.IsCommunity">
              <mat-expansion-panel-header>
                <mat-panel-title><mat-icon class="panel-icon">storefront</mat-icon> Loket</mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/loket" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active">Loketdossiers</a>
                <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/loket/calendar" routerLinkActive="active">Kalender</a>
                <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/reports/list-rpt" [routerLinkActiveOptions]="ignoreQueryMatching" routerLinkActive="active" [queryParams]="{ type: 'loket' }">Rapportering</a>
                <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/reports/list-wo" [routerLinkActiveOptions]="ignoreQueryMatching" routerLinkActive="active" [queryParams]="{ type: 'loket' }">Werkopdrachten</a>
                <a mat-list-item *ngIf="rootFolderLinkLoket" (click)="navigateRootDriveLoket()">Naar Sharepoint</a>
              </mat-nav-list>
              <div class="panel-sub-title">Loket instellingen</div>
              <mat-nav-list>
                <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/loket/partners" routerLinkActive="active">Partners</a>
                <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/loket/activiteiten-template" routerLinkActive="active">Activiteiten</a>
                <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/loket/activiteiten-types" routerLinkActive="active">Activiteitengroepen</a>
                <a mat-list-item *ngIf="moduleEid" (click)="uiState.toggleSideNav()" routerLink="/download-center" routerLinkActive="active">Download center</a>
              </mat-nav-list>
            </mat-expansion-panel>
          </ng-container>

          <!-- KOPPELINGEN -->
          <mat-expansion-panel *ngIf="moduleVLOK">
            <mat-expansion-panel-header>
              <mat-panel-title><mat-icon class="panel-icon">link</mat-icon> Koppelingen</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/vlok-uitzonderingen" routerLinkActive="active">VLOK Uitzonderingen</a>
            </mat-nav-list>
          </mat-expansion-panel>

          <!-- INSTELLINGEN -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title><mat-icon class="panel-icon">settings</mat-icon> Instellingen</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              <ng-container *screenResource="['BEDRIJFSGEGEVENS', 'READ']">
                <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/instellingen/bedrijfsgegevens" routerLinkActive="active">Algemeen</a>
              </ng-container>
              <ng-container *screenResource="['BEDRIJFSGEGEVENS', 'READ']">
                <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/instellingen/termijnen" routerLinkActive="active">Termijnbeheer</a>
              </ng-container>
              <ng-container *screenResource="['AMBTENAARBEHEER', 'READ']">
                <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/ambtenaren" routerLinkActive="active">Ambtenaarbeheer</a>
              </ng-container>
              <ng-container *screenResource="['GEBRUIKERSBEHEER', 'UPDATE']">
                <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/instellingen/gebruikers" routerLinkActive="active">Gebruikersbeheer</a>
              </ng-container>
              <ng-container *screenResource="['BRIEVENBEHEER', 'READ']">
                <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/instellingen/brievenbeheer" routerLinkActive="active">Brievenbeheer</a>
              </ng-container>
              <ng-container *screenResource="['VRIJSTELLINGSBEHEER', 'READ']">
                <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/instellingen/vrijstellingsbeheer" routerLinkActive="active">Vrijstellingsredenbeheer</a>
              </ng-container>
              <ng-container *screenResource="['BEDRIJFSGEGEVENS', 'READ']">
                <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/instellingen/dashboard" routerLinkActive="active">Dashboardbeheer</a>
              </ng-container>
            </mat-nav-list>
          </mat-expansion-panel>

          <!-- ANDERE -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title><mat-icon class="panel-icon">menu_book</mat-icon> Andere</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/documentation" routerLinkActive="active">Handleiding</a>
            </mat-nav-list>
          </mat-expansion-panel>

          <!-- ADMINISTRATOR -->
          <mat-expansion-panel *ngIf="authService.hasSuperadmin() | async">
            <mat-expansion-panel-header>
              <mat-panel-title><mat-icon class="panel-icon">admin_panel_settings</mat-icon> Admin</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/reports/builder/list" routerLinkActive="active">Rapportenbeheer</a>
              <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/automatisaties" routerLinkActive="active">Automatisaties</a>
              <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/admin/groups" routerLinkActive="active">Sharepoint Groepen</a>
              <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/admin/instellingen" routerLinkActive="active">Instellingen</a>
              <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/technical-report-template/list" routerLinkActive="active">Technische Verslagen Template</a>
              <a mat-list-item *ngIf="this.appState.activeCommunity$.value.IsCommunity" (click)="uiState.toggleSideNav()" routerLink="/instellingen/vlok-import" routerLinkActive="active">VLOK Import</a>
              <a mat-list-item (click)="uiState.toggleSideNav()" routerLink="/admin/swagger" routerLinkActive="active">Swagger</a>
            </mat-nav-list>
          </mat-expansion-panel>

        </mat-accordion>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar [style.backgroundImage]="'linear-gradient(to right, rgba(255,0,0,0), rgba(255,0,0,0), ' + toolbarColor + ')'">
      <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" class="topbar__left">
          <button (click)="uiState.toggleSideNav()" mat-icon-button>
            <mat-icon>menu</mat-icon>
          </button>
          <div routerLink="/" class="clickable" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
            <img class="logo" src="../../assets/logos/new_logo.svg" alt="Neglect-X Logo" />
          </div>
          <div class="breadcrumbs" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
            <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
              <div class="breadcrumb" *ngIf="!breadcrumb.routerLink">{{ breadcrumb.name }}</div>
              <div class="breadcrumb clickable" *ngIf="breadcrumb.routerLink" [routerLink]="breadcrumb.routerLink" >
                {{ breadcrumb.name }}
              </div>
              <mat-icon *ngIf="i !== breadcrumbs.length - 1">chevron_right</mat-icon>
            </ng-container>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" class="topbar__right">
          <button mat-stroked-button color="warn" *ngIf="hasStartedRoute" class="route-button" (click)="navigateToRoute()">Naar route</button>
          <div fxLayout="row" fxLayoutAlign="start center" *ngIf="!hasStartedRoute">
            <div class="community-name">
              {{ appState.activeCommunity$.value?.Name }}
            </div>

            <div *ngIf="appState.availableCommunities$.value.length > 1">
              <button mat-icon-button [matMenuTriggerFor]="communityMenu" [disabled]="!appState.allowedToChangeCommunity">
                <mat-icon>expand_more</mat-icon>
              </button>
              <mat-menu #communityMenu="matMenu">
                <ng-container *ngFor="let item of appState.availableCommunities$.value">
                  <button mat-menu-item (click)="changeCommunity(item)">
                    <mat-icon *ngIf="item.IsCommunity">location_city</mat-icon>
                    <mat-icon *ngIf="!item.IsCommunity">stars</mat-icon>
                    <span>{{ item?.Name }}</span>
                  </button>
                </ng-container>
              </mat-menu>
            </div>
          </div>
          <div fxHide.lt-md>
            {{ authService.user?.Name }}
          </div>
          <ng-container *screenResource="['HELPDESK', 'READ']">
            <div *ngIf="helpUrl">
              <a [href]="helpUrl" target="_blank" rel="noopener noreferrer">
                <button mat-icon-button matTooltip="Support">
                  <mat-icon>headset_mic</mat-icon>
                </button>
              </a>
            </div>
          </ng-container>
          <div fxLayout="row" fxLayoutGap="8px">
            <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="this.appState.activeCommunity$.value?.IsCommunity"><mat-icon>history</mat-icon></button>
            <mat-menu class="rowmenu" #menu="matMenu">
              <div class="mat-title">Bewerkt</div>
              <div fxLayout="row">
                <div fxLayout="column">
                  <div class="mat-subheading-2">Inventaris</div>
                  <ng-container *ngFor="let lastTouchedDossier of appState.lastTouchedDossiers$ | async">
                    <button mat-menu-item [routerLink]="['dossiers/', lastTouchedDossier.Code]">
                      {{ lastTouchedDossier.Code }} - {{ lastTouchedDossier.Street }} {{ lastTouchedDossier.HouseNumber }}
                      {{ lastTouchedDossier.BoxNumber }}
                    </button>
                  </ng-container>
                </div>
                <ng-container *screenResource="['LOKET', 'READ']">
                  <div fxLayout="column" *ngIf="moduleLoket">
                    <div class="mat-subheading-2">Loket</div>
                    <ng-container *ngFor="let dossier of appState.lastTouchedLoketDossiers$ | async">
                      <button mat-menu-item [routerLink]="['loket/', dossier.Id]">
                        {{ dossier.Code }} - {{ dossier.Street }} {{ dossier.HouseNumber }} {{ dossier.BoxNumber }}
                      </button>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
              <hr />
              <div class="mat-title">Geraadpleegd</div>
              <div fxLayout="row">
                <div fxLayout="column">
                  <div class="mat-subheading-2">Inventaris</div>
                  <ng-container *ngFor="let dossier of appState.lastVisitDossiers$ | async">
                    <button mat-menu-item [routerLink]="['dossiers/', dossier.Code]">
                      {{ dossier.Code }} - {{ dossier.Street }} {{ dossier.HouseNumber }} {{ dossier.BoxNumber }}
                    </button>
                  </ng-container>
                </div>
                <ng-container *screenResource="['LOKET', 'READ']">
                  <div fxLayout="column" *ngIf="moduleLoket">
                    <div class="mat-subheading-2">Loket</div>
                    <ng-container *ngFor="let dossier of appState.lastVisitLoketDossiers$ | async">
                      <button mat-menu-item [routerLink]="['loket/', dossier.Id]">
                        {{ dossier.Code }} - {{ dossier.Street }} {{ dossier.HouseNumber }} {{ dossier.BoxNumber }}
                      </button>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </mat-menu>
            <button mat-icon-button (click)="logout()"><mat-icon>logout</mat-icon></button>
          </div>
        </div>
      </div>
    </mat-toolbar>
    <router-outlet></router-outlet>
    <div fxLayout="row" fxLayoutAlign="center center" class="footer mat-elevation-z4">
      Neglect-X v{{ environment.appVersion }} © Aarixa bv{{ footerText?.length <= 0 ? "" : " - " + footerText }}
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
